<ng-container [ngSwitch]="valueType">
  <span *ngSwitchCase="'number'" [innerHTML]="$any(_value) | eneUnit: config?.unitConfig" [class.body-md]="altTheme"></span>
  <span
    *ngSwitchCase="'string'"
    tooltipIfTruncated
    [innerHTML]="$any(_value) | translate"
    [matTooltip]="$any(_value) | translate"
    [class.body-md]="altTheme"
  ></span>
  <span *ngSwitchCase="'undefined'" [class.body-md]="altTheme">
    {{ "TDI.NOT_AVAILABLE.LONG" | translate }}
  </span>
  <span *ngSwitchDefault [class.body-md]="altTheme">-</span>
</ng-container>
